import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';

import styles from './spinner.module.css';

const Spinner = ({ center, size }) => (
  <div className={cn(styles.spinnerWrapper, center)}>
    <div className={cn(styles.spinner, size)}>
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
    </div>
  </div>
);

Spinner.propTypes = {
  size: PropTypes.string,
  center: PropTypes.bool
};

Spinner.defaultProps = {
  size: 'sm',
  center: true
};

export default Spinner;
